<app-deals-dashboard *ngIf="!message" [loading]="loading" title="Associa Fascicolo" [embedded]="true" (onSelect)="onLeadSelection($event)"></app-deals-dashboard>

<div *ngIf="message" class="blocking-overlay d-flex justify-content-center align-items-center w-100 h-100">
    {{message}}
</div>